module.exports = __webpack_public_path__ + "img/12.0b7b7aae.jpg";